(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pearl-cart-drawer"]) return;
  try {
    
  class PearlCartDrawer extends HTMLElement {
    connectedCallback() {
      this.overlay = this.querySelector('[data-overlay]');
      this.closeBtn = this.querySelector('[data-close]');
      this.body = this.querySelector('[data-cart-body]');

      if (this.overlay) this.overlay.addEventListener('click', () => this.close());
      if (this.closeBtn) this.closeBtn.addEventListener('click', () => this.close());

      this.addEventListener('click', (e) => {
        const removeBtn = e.target.closest('[data-line-remove]');
        if (removeBtn) {
          e.preventDefault();
          this.changeLine(removeBtn.dataset.lineKey, 0);
          return;
        }
        const stepBtn = e.target.closest('[data-line-step]');
        if (stepBtn) {
          e.preventDefault();
          const item = stepBtn.closest('[data-line-item]');
          const qtyEl = item ? item.querySelector('[data-line-qty]') : null;
          const current = qtyEl ? parseInt(qtyEl.textContent, 10) : 0;
          const delta = parseInt(stepBtn.dataset.lineStep, 10);
          const next = Math.max(0, current + delta);
          this.changeLine(stepBtn.dataset.lineKey, next);
        }
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.dataset.open === 'true') this.close();
      });

      // Listen for global open events
      document.addEventListener('pearl:cart:open', () => this.open());
      document.addEventListener('pearl:cart:refresh', () => this.refresh());
      document.addEventListener('pearl:cart:added', () => {
        this.refresh().then(() => this.open());
      });

      // Intercept clicks on cart links anywhere on the page
      document.addEventListener('click', (e) => {
        const link = e.target.closest('a[href$="/cart"]');
        if (link && !link.hasAttribute('data-no-drawer')) {
          e.preventDefault();
          this.open();
        }
      });
    }

    open() {
      this.dataset.open = 'true';
      this.removeAttribute('inert');
      this.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
    }

    close() {
      this.removeAttribute('data-open');
      this.setAttribute('inert', '');
      this.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    }

    async refresh() {
      this.dataset.loading = 'true';
      try {
        const res = await fetch('/?sections=pearl-cart-drawer', { headers: { Accept: 'application/json' } });
        const data = await res.json();
        const html = data['pearl-cart-drawer'];
        if (html) {
          const tmp = document.createElement('div');
          tmp.innerHTML = html;
          const fresh = tmp.querySelector('pearl-cart-drawer');
          if (fresh) {
            this.innerHTML = fresh.innerHTML;
            this.connectedCallback();
            this.updateHeaderCount();
          }
        }
      } catch (e) {
        console.error('Cart refresh failed', e);
      } finally {
        this.removeAttribute('data-loading');
      }
    }

    async changeLine(key, quantity) {
      this.dataset.loading = 'true';
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity })
        });
        await res.json();
        await this.refresh();
      } catch (e) {
        console.error('Cart change failed', e);
        this.removeAttribute('data-loading');
      }
    }

    updateHeaderCount() {
      fetch('/cart.js').then(r => r.json()).then(cart => {
        document.querySelectorAll('[data-cart-count]').forEach(el => {
          el.textContent = String(cart.item_count);
          el.dataset.empty = cart.item_count === 0 ? 'true' : 'false';
        });
      }).catch(() => {});
    }
  }

  if (!customElements.get('pearl-cart-drawer')) {
    customElements.define('pearl-cart-drawer', PearlCartDrawer);
  }

  /* Universal AJAX add-to-cart for all pearl-product forms on the page */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    if (form.hasAttribute('data-no-drawer')) return;

    e.preventDefault();
    const submit = form.querySelector('[type="submit"]');
    if (submit) {
      submit.disabled = true;
      submit.dataset.originalLabel = submit.dataset.originalLabel || (submit.querySelector('[data-cart-label]')?.textContent || submit.textContent);
      const label = submit.querySelector('[data-cart-label]') || submit;
      label.textContent = 'Tilføjer...';
    }

    try {
      const formData = new FormData(form);
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' }
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'Add failed');
      document.dispatchEvent(new CustomEvent('pearl:cart:added', { detail: data }));
    } catch (err) {
      console.error('Add to cart failed:', err);
      alert('Kunne ikke tilføje til kurv. Prøv igen.');
    } finally {
      if (submit) {
        submit.disabled = false;
        const label = submit.querySelector('[data-cart-label]') || submit;
        if (submit.dataset.originalLabel) label.textContent = submit.dataset.originalLabel;
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pearl-header"] && !Shopify.designMode) return;
  try {
    
  class PearlHeader extends HTMLElement {
    connectedCallback() {
      this.bar = this.querySelector('.pearl-header__bar');
      this.burger = this.querySelector('.pearl-header__burger');
      this.drawer = this.querySelector('.pearl-header__drawer');
      this.cartCount = this.querySelector('.pearl-header__cart-count');

      if (this.cartCount) {
        const value = parseInt(this.cartCount.textContent, 10);
        this.cartCount.dataset.empty = value === 0 ? 'true' : 'false';
      }

      if (this.burger && this.drawer) {
        this.burger.addEventListener('click', () => this.toggleDrawer());
        document.addEventListener('click', (e) => {
          if (!this.contains(e.target) && this.drawer.dataset.open === 'true') this.toggleDrawer();
        });
      }

      const cartBtn = this.querySelector('[data-open-cart]');
      if (cartBtn) {
        cartBtn.addEventListener('click', () => {
          document.dispatchEvent(new CustomEvent('pearl:cart:open'));
        });
      }

      if (this.dataset.sticky === 'true') {
        this.handleScroll = this.handleScroll.bind(this);
        window.addEventListener('scroll', this.handleScroll, { passive: true });
        this.handleScroll();
      }
    }

    toggleDrawer() {
      const open = this.burger.getAttribute('aria-expanded') === 'true';
      this.burger.setAttribute('aria-expanded', String(!open));
      if (!open) {
        this.drawer.hidden = false;
        requestAnimationFrame(() => this.drawer.setAttribute('data-open', 'true'));
      } else {
        this.drawer.removeAttribute('data-open');
        this.drawer.hidden = true;
      }
    }

    handleScroll() {
      const scrolled = window.scrollY > 8;
      this.dataset.scrolled = scrolled ? 'true' : 'false';
    }
  }

  if (!customElements.get('pearl-header')) {
    customElements.define('pearl-header', PearlHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pearl-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function closeModal(modal) {
      if (!modal) return;
      var v = modal.querySelector('video'); if (v) { try { v.pause(); } catch (e) {} }
      var f = modal.querySelector('iframe'); if (f) { f.src = f.src; }
      if (typeof modal.close === 'function') { try { modal.close(); } catch (e) { modal.removeAttribute('open'); } }
      else { modal.removeAttribute('open'); }
    }
    document.addEventListener('click', function (e) {
      var opener = e.target.closest && e.target.closest('[data-pearl-video-open]');
      if (opener) {
        e.preventDefault();
        var sec = opener.closest('.pearl-hero-section') || opener.closest('section') || document;
        var modal = sec.querySelector('[data-pearl-video-modal]');
        if (modal) {
          if (typeof modal.showModal === 'function') { try { modal.showModal(); } catch (e2) { modal.setAttribute('open', ''); } }
          else { modal.setAttribute('open', ''); }
          var v = modal.querySelector('video'); if (v) { try { v.play(); } catch (e3) {} }
        }
        return;
      }
      var closer = e.target.closest && e.target.closest('[data-pearl-video-close]');
      if (closer) { closeModal(closer.closest('[data-pearl-video-modal]')); return; }
      if (e.target.matches && e.target.matches('[data-pearl-video-modal]')) { closeModal(e.target); }
    });
    document.addEventListener('cancel', function (e) {
      if (e.target && e.target.matches && e.target.matches('[data-pearl-video-modal]')) closeModal(e.target);
    }, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pearl-product"] && !Shopify.designMode) return;
  try {
    
  class PearlProduct extends HTMLElement {
    connectedCallback() {
      this.variants = this.parseVariants();
      this.optionInputs = this.querySelectorAll('[data-option-input]');
      this.variantInput = this.querySelector('[data-variant-id-input]');
      this.cartLabel = this.querySelector('[data-cart-label]');
      this.submitBtn = this.querySelector('[data-add-to-cart]');
      this.qtyInput = this.querySelector('[data-qty-input]');
      this.qtyButtons = this.querySelectorAll('[data-qty-step]');
      this.optionDisplays = this.querySelectorAll('[data-option-value-display]');

      this.optionInputs.forEach((input) => {
        input.addEventListener('change', () => this.handleOptionChange());
      });
      this.qtyButtons.forEach((btn) => {
        btn.addEventListener('click', () => this.stepQty(parseInt(btn.dataset.qtyStep, 10)));
      });
      if (this.qtyInput) {
        this.qtyInput.addEventListener('input', () => this.updateCartLabel());
        this.qtyInput.addEventListener('change', () => this.updateCartLabel());
      }

      this.form = this.querySelector('#pearl-product-form');
      if (this.form) {
        this.form.addEventListener('submit', (e) => this.handleSubmit(e));
      }
    }

    async handleSubmit(event) {
      const qbreak = this.querySelector('pearl-quantity-break');
      if (!qbreak || typeof qbreak.getSelectedItems !== 'function') return;
      const items = qbreak.getSelectedItems();
      if (!items) return;

      event.preventDefault();
      if (this.submitBtn) this.submitBtn.disabled = true;
      const prevLabel = this.cartLabel?.textContent;
      if (this.cartLabel) this.cartLabel.textContent = 'Tilføjer…';

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items }),
        });
        if (!response.ok) throw new Error('add-failed');
        if (this.cartLabel) this.cartLabel.textContent = 'Tilføjet ✓';
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:updated'));
        setTimeout(() => {
          if (this.cartLabel) this.cartLabel.textContent = prevLabel || 'Tilføj til kurv';
          if (this.submitBtn) this.submitBtn.disabled = false;
        }, 1500);
      } catch (err) {
        if (this.cartLabel) this.cartLabel.textContent = 'Prøv igen';
        setTimeout(() => {
          if (this.cartLabel) this.cartLabel.textContent = prevLabel || 'Tilføj til kurv';
          if (this.submitBtn) this.submitBtn.disabled = false;
        }, 1500);
      }
    }

    parseVariants() {
      const node = this.querySelector('[data-product-json]');
      if (!node) return [];
      try { return JSON.parse(node.textContent); } catch (e) { return []; }
    }

    handleOptionChange() {
      const selected = [];
      this.optionInputs.forEach((input) => {
        if (input.checked) selected[parseInt(input.dataset.optionPosition, 10)] = input.value;
      });
      this.optionDisplays.forEach((el, idx) => {
        if (selected[idx]) el.textContent = selected[idx];
      });
      const matched = this.variants.find((v) => v.options.every((opt, idx) => opt === selected[idx]));
      if (!matched) { this.setUnavailable(); return; }
      if (this.variantInput) this.variantInput.value = matched.id;
      this.updateButton(matched);
      this.updatePrice(matched);
      this.updateUrl(matched.id);
      this.updateGalleryImage(matched);
    }

    updateGalleryImage(variant) {
      if (!variant.featured_image) return;
      const gallery = this.querySelector('pearl-gallery');
      if (!gallery || typeof gallery.activate !== 'function') return;
      const targetIndex = (variant.featured_image.position || 1) - 1;
      gallery.activate(targetIndex);
    }

    setUnavailable() {
      if (this.submitBtn) this.submitBtn.disabled = true;
      if (this.cartLabel) this.cartLabel.textContent = 'Udsolgt';
    }

    updateButton(variant) {
      if (!this.submitBtn) return;
      this.submitBtn.disabled = !variant.available;
      this.updateCartLabel(variant);
    }

    updateCartLabel(variant) {
      if (!this.cartLabel) return;
      if (!variant && this.variantInput) {
        const id = parseInt(this.variantInput.value, 10);
        variant = this.variants.find((v) => v.id === id);
      }
      if (!variant) return;
      if (!variant.available) {
        this.cartLabel.textContent = 'Udsolgt';
        return;
      }
      const qty = Math.max(1, parseInt(this.qtyInput?.value || '1', 10));
      const total = this.formatMoney(variant.price * qty);
      this.cartLabel.textContent = qty > 1
        ? `Tilføj ${qty} til kurv — ${total}`
        : `Tilføj til kurv — ${total}`;
    }

    updatePrice(variant) {
      const now = this.querySelector('.pearl-product__price-now');
      const was = this.querySelector('.pearl-product__price-was');
      if (now) now.textContent = this.formatMoney(variant.price);
      if (was) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          was.textContent = this.formatMoney(variant.compare_at_price);
          was.style.display = '';
        } else {
          was.style.display = 'none';
        }
      }
    }

    updateUrl(variantId) {
      if (!history.replaceState) return;
      const url = new URL(window.location);
      url.searchParams.set('variant', variantId);
      history.replaceState({}, '', url.toString());
    }

    stepQty(delta) {
      if (!this.qtyInput) return;
      const next = Math.max(1, parseInt(this.qtyInput.value, 10) + delta);
      this.qtyInput.value = String(next);
      this.updateCartLabel();
    }

    formatMoney(cents) {
      const amount = (cents / 100).toFixed(2).replace('.', ',');
      return `${amount} kr.`;
    }
  }

  if (!customElements.get('pearl-product')) {
    customElements.define('pearl-product', PearlProduct);
  }

  /* Gallery: classic main + thumbs with swipe support on mobile */
  class PearlGallery extends HTMLElement {
    connectedCallback() {
      this.main = this.querySelector('[data-main]');
      this.slides = this.querySelectorAll('[data-slide-index]');
      this.thumbs = this.querySelectorAll('[data-thumb]');
      this.arrows = this.querySelectorAll('[data-arrow]');
      this.counter = this.querySelector('[data-current]');
      this.activeIndex = 0;
      this.total = this.slides.length;

      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => this.activate(parseInt(thumb.dataset.thumb, 10)));
      });

      this.arrows.forEach((arrow) => {
        arrow.addEventListener('click', () => {
          const dir = parseInt(arrow.dataset.arrow, 10);
          this.activate((this.activeIndex + dir + this.total) % this.total);
        });
      });

      if (this.main) {
        let startX = 0;
        this.main.addEventListener('touchstart', (e) => {
          startX = e.touches[0].clientX;
        }, { passive: true });
        this.main.addEventListener('touchend', (e) => {
          const diff = e.changedTouches[0].clientX - startX;
          if (Math.abs(diff) > 40) {
            const dir = diff < 0 ? 1 : -1;
            this.activate((this.activeIndex + dir + this.total) % this.total);
          }
        }, { passive: true });
      }
    }

    activate(index) {
      this.activeIndex = index;
      this.slides.forEach((slide) => {
        slide.dataset.active = String(parseInt(slide.dataset.slideIndex, 10) === index);
      });
      this.thumbs.forEach((thumb) => {
        const match = parseInt(thumb.dataset.thumb, 10) === index;
        thumb.dataset.active = String(match);
        if (match) thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      });
      if (this.counter) this.counter.textContent = String(index + 1);
    }
  }

  if (!customElements.get('pearl-gallery')) {
    customElements.define('pearl-gallery', PearlGallery);
  }

  /* Inline upsell: AJAX add to cart */
  class PearlUpsell extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-upsell-form]');
      this.button = this.querySelector('[data-upsell-add]');
      this.label = this.querySelector('[data-upsell-label]');
      this.originalLabel = this.label ? this.label.textContent : 'Tilføj';

      if (this.form) {
        this.form.addEventListener('submit', (e) => this.handleSubmit(e));
      }
    }

    async handleSubmit(event) {
      event.preventDefault();
      if (!this.button || this.button.disabled) return;
      this.button.disabled = true;
      if (this.label) this.label.textContent = 'Tilføjer…';

      try {
        const formData = new FormData(this.form);
        const response = await fetch(this.form.action, {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: formData,
        });
        if (!response.ok) throw new Error('add-failed');
        if (this.label) this.label.textContent = 'Tilføjet ✓';
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:updated'));
        setTimeout(() => {
          if (this.label) this.label.textContent = this.originalLabel;
          this.button.disabled = false;
        }, 1800);
      } catch (err) {
        if (this.label) this.label.textContent = 'Prøv igen';
        setTimeout(() => {
          if (this.label) this.label.textContent = this.originalLabel;
          this.button.disabled = false;
        }, 1800);
      }
    }
  }

  if (!customElements.get('pearl-upsell')) {
    customElements.define('pearl-upsell', PearlUpsell);
  }

  /* Quantity break: tier selector with per-tier variant chips */
  class PearlQuantityBreak extends HTMLElement {
    connectedCallback() {
      this.perItem = this.dataset.perItem === 'true';
      this.inputs = this.querySelectorAll('[data-qbreak-input]');
      this.tiers = this.querySelectorAll('.pearl-product__qbreak-tier');
      this.optionsData = this.parseOptions();

      this.inputs.forEach((input) => {
        input.addEventListener('change', () => this.handleTierChange(input));
      });

      const preselected = Array.from(this.inputs).find((i) => i.checked);
      if (preselected) this.handleTierChange(preselected);
    }

    parseOptions() {
      const node = this.querySelector('[data-qbreak-options]');
      if (!node) return null;
      try { return JSON.parse(node.textContent); } catch (e) { return null; }
    }

    handleTierChange(input) {
      const qty = parseInt(input.value, 10);
      if (isNaN(qty) || qty < 1) return;
      this.currentQty = qty;

      this.tiers.forEach((t) => t.classList.remove('pearl-product__qbreak-tier--active'));
      const tier = input.closest('.pearl-product__qbreak-tier');
      if (tier) tier.classList.add('pearl-product__qbreak-tier--active');

      this.syncQty(qty);
    }

    syncQty(qty) {
      const root = this.closest('pearl-product') || document;
      const qtyInput = root.querySelector('[data-qty-input]');
      if (!qtyInput) return;
      qtyInput.value = String(qty);
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    getSelectedItems() {
      if (!this.perItem || !this.optionsData) return null;
      const activeTier = this.querySelector('.pearl-product__qbreak-tier--active')
        || this.querySelector('input[data-qbreak-input]:checked')?.closest('.pearl-product__qbreak-tier');
      if (!activeTier) return null;
      const slotInputs = activeTier.querySelectorAll('[data-tier-slot-input]:checked');
      if (!slotInputs.length) return null;
      const items = [];
      slotInputs.forEach((input) => {
        const variant = this.optionsData.variant_map[input.value];
        if (variant && variant.available) items.push({ id: variant.id, quantity: 1 });
      });
      return items.length ? items : null;
    }
  }

  if (!customElements.get('pearl-quantity-break')) {
    customElements.define('pearl-quantity-break', PearlQuantityBreak);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pearl-testimonials"] && !Shopify.designMode) return;
  try {
    
  class PearlTestimonialCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.dots = this.querySelectorAll('[data-dot-target]');
      if (!this.track || this.dots.length < 2) return;

      this.index = 0;
      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.go(parseInt(dot.dataset.dotTarget, 10)));
      });

      this.startAutoplay();
      this.addEventListener('mouseenter', () => clearInterval(this.timer));
      this.addEventListener('mouseleave', () => this.startAutoplay());
    }

    go(index) {
      this.index = index;
      this.track.style.transform = `translateX(-${index * 100}%)`;
      this.dots.forEach((dot) => {
        dot.dataset.active = String(parseInt(dot.dataset.dotTarget, 10) === index);
      });
    }

    startAutoplay() {
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.go((this.index + 1) % this.dots.length);
      }, 7000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }
  }

  if (!customElements.get('pearl-testimonial-carousel')) {
    customElements.define('pearl-testimonial-carousel', PearlTestimonialCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pearl-ugc-videos"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setPaused(state) {
      document.querySelectorAll('.pearl-ugc__viewport').forEach(function (vp) {
        if (state) vp.setAttribute('data-paused', 'true');
        else vp.removeAttribute('data-paused');
      });
    }
    function openModal(modal) {
      if (!modal) return;
      if (typeof modal.showModal === 'function') { try { modal.showModal(); } catch (e) { modal.setAttribute('open', ''); } }
      else { modal.setAttribute('open', ''); }
      var v = modal.querySelector('video'); if (v) { try { v.play(); } catch (e) {} }
      setPaused(true);
    }
    function closeModal(modal) {
      if (!modal) return;
      var v = modal.querySelector('video'); if (v) { try { v.pause(); } catch (e) {} }
      var f = modal.querySelector('iframe'); if (f) { f.src = f.src; }
      if (typeof modal.close === 'function') { try { modal.close(); } catch (e) { modal.removeAttribute('open'); } }
      else { modal.removeAttribute('open'); }
      setPaused(false);
    }
    document.addEventListener('click', function (e) {
      var opener = e.target.closest && e.target.closest('[data-ugc-open]');
      if (opener) {
        e.preventDefault();
        var sec = opener.closest('.pearl-ugc');
        var id = opener.getAttribute('data-ugc-open');
        var modal = sec && sec.querySelector('[data-ugc-modal="' + id + '"]');
        openModal(modal);
        return;
      }
      var closer = e.target.closest && e.target.closest('[data-ugc-close]');
      if (closer) { closeModal(closer.closest('[data-ugc-modal]')); return; }
      if (e.target.matches && e.target.matches('[data-ugc-modal]')) { closeModal(e.target); }
    });
    document.addEventListener('cancel', function (e) {
      if (e.target && e.target.matches && e.target.matches('[data-ugc-modal]')) closeModal(e.target);
    }, true);
  })();

  } catch(e) { console.error(e); }
})();
})();
